import { getAxiosClient, getAxiosClientWithToken } from './index';
import qs from 'qs';
import { ProfileFieldData } from 'types';

export const fetchUserRegistrationData = (uuid: string, expires: string, signature: string) => {
    const restClient = getAxiosClient();
    return restClient.get('/company/register/' + uuid, { params: { expires: expires, signature: signature } });
};

export const getUserData = () => {
    const restClient = getAxiosClientWithToken();
    return restClient.get('/user');
};

export const getProfile = (uuid: string) => {
    const restClient = getAxiosClientWithToken();
    return restClient.get('/company/users/' + uuid);
};

export const saveProfile = (uuid: string, data: ProfileFieldData) => {
    const restClient = getAxiosClientWithToken();

    return restClient.put('/company/users/' + uuid, qs.stringify(data), {
        headers: {
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
        },
    });
};

// update profile
export const updateProfile = (name: string, email: string) => {
    const restClient = getAxiosClientWithToken();
    return restClient.post('/admin/user/update-profile', { name: name, email: email });
};

export const exportUsers = (roleId: number) => {
    const restClient = getAxiosClientWithToken();
    return restClient.get('/admin/users/export', {
        params: { role_id: roleId },
        responseType: 'arraybuffer',
    });
};
